import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "status-wrapper" }
const _hoisted_2 = { class: "status-bar" }

import { computed } from "vue";
import TimelineStep from "@/components/timeline/TimelineStep.vue";
import TimelineStepDescription from "@/components/timeline/TimelineStepDescription.vue";
import { ProductIds } from "@/config/constants";
import useApplicationStatus from "@/composables/application-status/useApplicationStatus";
import { TimelineMilestone, TimelineMilestoneStatus } from "@/models/applicationStatus";
import UnderReviewText from "@/components/application-statuses/EvaluationQueue/UnderReviewText.vue";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'EvaluationQueue',
  emits: ["todoListClicked"],
  setup(__props, { emit: __emit }) {

useStore();

const emit = __emit;

const { productTypeId, useV2, timeline, currentstep, selectedStep, stepCount } =
  useApplicationStatus();

const steps = computed(() => timeline.value.filter((s: TimelineMilestone) => s.step > 1));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(productTypeId) === _unref(ProductIds).REFI)
        ? (_openBlock(), _createBlock(TimelineStep, {
            key: 0,
            status: "active",
            step: 1,
            title: "Application Under Review",
            maximumStep: _unref(stepCount)
          }, {
            caption: _withCtx(() => [
              _createVNode(UnderReviewText, {
                onTodoListClicked: _cache[0] || (_cache[0] = ($event: any) => (emit('todoListClicked')))
              })
            ]),
            _: 1
          }, 8, ["maximumStep"]))
        : (_openBlock(), _createBlock(TimelineStep, {
            key: 1,
            status: "active",
            step: 1,
            title: "Application Under Review",
            maximumStep: _unref(stepCount)
          }, {
            caption: _withCtx(() => [
              _createVNode(TimelineStepDescription, {
                class: "mobile",
                step: 1,
                status: "active"
              }, {
                description: _withCtx(() => [
                  _createVNode(UnderReviewText)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["maximumStep"])),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step) => {
        return (_openBlock(), _createBlock(TimelineStep, {
          key: step.id,
          status: step.status,
          step: step.step,
          title: step.title,
          maximumStep: _unref(timeline)?.length,
          configuration: step,
          onTitleClicked: _cache[1] || (_cache[1] = ($event: any) => (currentstep.value = $event)),
          onTodoListClicked: _cache[2] || (_cache[2] = ($event: any) => (emit('todoListClicked')))
        }, _createSlots({ _: 2 }, [
          (_unref(useV2) && _unref(currentstep) === step.step)
            ? {
                name: "caption",
                fn: _withCtx(() => [
                  _createVNode(TimelineStepDescription, {
                    class: "mobile",
                    step: step.step,
                    status: _unref(selectedStep).status
                  }, null, 8, ["step", "status"])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["status", "step", "title", "maximumStep", "configuration"]))
      }), 128))
    ]),
    (_unref(useV2))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divider" }, null, -1)),
          _createVNode(TimelineStepDescription, {
            step: 1,
            status: _unref(TimelineMilestoneStatus).ACTIVE
          }, {
            default: _withCtx(() => [
              _createVNode(UnderReviewText)
            ]),
            _: 1
          }, 8, ["status"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})